import { createSelector } from 'reselect';

/**
 * Direct selector to the notificationEngine state domain
 */
const selectNotificationEngineDomain = (state) => state.get('notificationEngine');

/**
 * Other specific selectors
 */

/**
 * Default selector used by NotificationEngine
 */

const makeSelectNotificationEngine = () => createSelector(
  selectNotificationEngineDomain,
  (substate) => substate.toJS()
);

export default makeSelectNotificationEngine;
export {
  selectNotificationEngineDomain,
};
